
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import tabbar from '@/components/tabbar'
export default{
components: {
XHeader,
Group,
tabbar,
XButton,
Cell
},
data(){
return{
uInfs:{}
}
},
mounted(){

},
methods:{
relogin() {
localStorage.removeItem('loginData');
this.$router.push({
path: '/'
});
},
getUDatas(){
let _this = this;
let uObj ={};
if(window.sessionStorage.userInfo){
let uObj = JSON.parse(window.sessionStorage.userInfo);
let useId = uObj.user_id;
_this.$http.get('/userinfo',{
params:{
uId:useId
}
}).then((res)=>{
_this.uInfs = res.data;

},(err)=>{

});
}else{
_this.$router.push({
path:'/login',
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/vipCenter.vue